
















































































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountLendingScheduleSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/Schedule/AccountLendingScheduleSettings';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountLendingScheduleSettingsRead' })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountLendingScheduleSettings;

}
